const flag_base_path = 'https://caccount.policybazaar.com/Content/countryIcon/';
const flag_base_path_static = 'https://static.pbcdn.in/myaccount-cdn/images/countyflags/';
const CDN_IMG_BASEURL = "https://pbqa.policybazaar.com/cdn/images/";
const CountryJson = [
    {
        "CountryId": 1,
        "Country": "AFGHANISTAN",
        "CountryCode": "+93",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/af.svg"
    },
    {
        "CountryId": 2,
        "Country": "AFRICAN REP-SPECIAL",
        "CountryCode": "+61",
        "TIMEZONE": 15,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/afr.svg"
    },
    {
        "CountryId": 5,
        "Country": "ALBANIA",
        "CountryCode": "+355",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/al.svg"
    },
    {
        "CountryId": 6,
        "Country": "ALGERIA",
        "CountryCode": "+213",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/dz.svg"
    },
    {
        "CountryId": 8,
        "Country": "AMERICAN SAMOA",
        "CountryCode": "+1684",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/as.svg"
    },
    {
        "CountryId": 10,
        "Country": "ANDORRA",
        "CountryCode": "+376",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ad.svg"
    },
    {
        "CountryId": 11,
        "Country": "ANGOLA",
        "CountryCode": "+244",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ao.svg"
    },
    {
        "CountryId": 12,
        "Country": "ANGUILLA",
        "CountryCode": "+1264",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ai.svg"
    },
    {
        "CountryId": 13,
        "Country": "ANTARCTICA",
        "CountryCode": "+6721",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 14,
        "Country": "ANTIGUA & BARBUDA",
        "CountryCode": "+1268",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ag.svg"
    },
    {
        "CountryId": 15,
        "Country": "ANTILLES NETHERLANDS",
        "CountryCode": "+599",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/ant.svg"
    },
    {
        "CountryId": 16,
        "Country": "ARGENTINA",
        "CountryCode": "+54",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ar.svg"
    },
    {
        "CountryId": 17,
        "Country": "ARMENIA",
        "CountryCode": "+374",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/am.svg"
    },
    {
        "CountryId": 21,
        "Country": "ARUBA",
        "CountryCode": "+297",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/aw.svg"
    },
    {
        "CountryId": 22,
        "Country": "ASCENSION ISLAND",
        "CountryCode": "+247",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/asc.svg"
    },
    {
        "CountryId": 23,
        "Country": "ATLANTIC WEST (SAT)",
        "CountryCode": "+874",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 26,
        "Country": "AUSTRIA",
        "CountryCode": "+43",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/at.svg"
    },
    {
        "CountryId": 33,
        "Country": "AZERBAIJAN",
        "CountryCode": "+994",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/az.svg"
    },
    {
        "CountryId": 34,
        "Country": "BAHAMAS",
        "CountryCode": "+1242",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bs.svg"
    },
    {
        "CountryId": 35,
        "Country": "BAHRAIN",
        "CountryCode": "+973",
        "TIMEZONE": 2,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bh.svg"
    },
    {
        "CountryId": 36,
        "Country": "BANGLADESH",
        "CountryCode": "+880",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bd.svg"
    },
    {
        "CountryId": 37,
        "Country": "BARBADOS",
        "CountryCode": "+1246",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bb.svg"
    },
    {
        "CountryId": 40,
        "Country": "BELARUS",
        "CountryCode": "+375",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/by.svg"
    },
    {
        "CountryId": 41,
        "Country": "BELGIUM",
        "CountryCode": "+32",
        "TIMEZONE": 16,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/be.svg"
    },
    {
        "CountryId": 44,
        "Country": "BELIZE",
        "CountryCode": "+501",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bz.svg"
    },
    {
        "CountryId": 45,
        "Country": "BENIN",
        "CountryCode": "+229",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bj.svg"
    },
    {
        "CountryId": 46,
        "Country": "BERMUDA",
        "CountryCode": "+1441",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bm.svg"
    },
    {
        "CountryId": 47,
        "Country": "BHUTAN",
        "CountryCode": "+975",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bt.svg"
    },
    {
        "CountryId": 48,
        "Country": "BOLIVIA",
        "CountryCode": "+591",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bo.svg"
    },
    {
        "CountryId": 50,
        "Country": "BOSNIA",
        "CountryCode": "+387",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ba.svg"
    },
    {
        "CountryId": 51,
        "Country": "BOTSWANA",
        "CountryCode": "+267",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bw.svg"
    },
    {
        "CountryId": 52,
        "Country": "BRAZIL",
        "CountryCode": "+55",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/br.svg"
    },
    {
        "CountryId": 54,
        "Country": "BRITISH VIRGIN ISLAND",
        "CountryCode": "+1284",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 55,
        "Country": "BRUNEI",
        "CountryCode": "+673",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bn.svg"
    },
    {
        "CountryId": 57,
        "Country": "BULGARIA",
        "CountryCode": "+359",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bg.svg"
    },
    {
        "CountryId": 59,
        "Country": "BURKINA FASSO",
        "CountryCode": "+226",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bf.svg"
    },
    {
        "CountryId": 60,
        "Country": "BURUNDI",
        "CountryCode": "+257",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/bi.svg"
    },
    {
        "CountryId": 61,
        "Country": "CAMBODIA",
        "CountryCode": "+855",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/kh.svg"
    },
    {
        "CountryId": 62,
        "Country": "CAMEROON",
        "CountryCode": "+237",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/cm.svg"
    },
    {
        "CountryId": 63,
        "Country": "CANADA",
        "CountryCode": "+1867",
        "TIMEZONE": 3,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ca.svg"
    },
    {
        "CountryId": 64,
        "Country": "CAPE VERDE ISLAND",
        "CountryCode": "+238",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/cap.svg"
    },
    {
        "CountryId": 65,
        "Country": "CAYMAN ISLAND",
        "CountryCode": "+1345",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ky.svg"
    },
    {
        "CountryId": 66,
        "Country": "CENTRAL AFRICAN REP",
        "CountryCode": "+236",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/cf.svg"
    },
    {
        "CountryId": 69,
        "Country": "CHAD(REPUBLIC)",
        "CountryCode": "+235",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/td.svg"
    },
    {
        "CountryId": 70,
        "Country": "CHILE",
        "CountryCode": "+56",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/cl.svg"
    },
    {
        "CountryId": 72,
        "Country": "CHINA",
        "CountryCode": "+86",
        "TIMEZONE": 17,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/cn.svg"
    },
    {
        "CountryId": 73,
        "Country": "COLOMBIA",
        "CountryCode": "+57",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/co.svg"
    },
    {
        "CountryId": 74,
        "Country": "COMOROS",
        "CountryCode": "+269",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/km.svg"
    },
    {
        "CountryId": 75,
        "Country": "CONGO PEOPLES REPUBL",
        "CountryCode": "+242",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/cpr.svg"
    },
    {
        "CountryId": 77,
        "Country": "COOK ISLAND",
        "CountryCode": "+682",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ck.svg"
    },
    {
        "CountryId": 78,
        "Country": "COST RICA",
        "CountryCode": "+506",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/cr.svg"
    },
    {
        "CountryId": 79,
        "Country": "CROATIA",
        "CountryCode": "+385",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/hr.svg"
    },
    {
        "CountryId": 83,
        "Country": "CUBA",
        "CountryCode": "+53",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/cu.svg"
    },
    {
        "CountryId": 86,
        "Country": "CYPRUS",
        "CountryCode": "+357",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/cy.svg"
    },
    {
        "CountryId": 89,
        "Country": "CZECH",
        "CountryCode": "+420",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/cz.svg"
    },
    {
        "CountryId": 91,
        "Country": "DEM. REP. OF CONGO",
        "CountryCode": "+243",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/cd.svg"
    },
    {
        "CountryId": 92,
        "Country": "DENMARK",
        "CountryCode": "+45",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/dk.svg"
    },
    {
        "CountryId": 96,
        "Country": "DIEGO GARCIA",
        "CountryCode": "+246",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/die.svg"
    },
    {
        "CountryId": 97,
        "Country": "DJIBOUTI",
        "CountryCode": "+253",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/dji.svg"
    },
    {
        "CountryId": 98,
        "Country": "DOMINICA",
        "CountryCode": "+1767",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/dm.svg"
    },
    {
        "CountryId": 99,
        "Country": "DOMINICA REP",
        "CountryCode": "+1829",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/do.svg"
    },
    {
        "CountryId": 101,
        "Country": "EGYPT",
        "CountryCode": "+20",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/eg.svg"
    },
    {
        "CountryId": 102,
        "Country": "EL SALVADOR REPUBLIC",
        "CountryCode": "+503",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sv.svg"
    },
    {
        "CountryId": 103,
        "Country": "EQUADOR",
        "CountryCode": "+593",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ec.svg"
    },
    {
        "CountryId": 104,
        "Country": "EQUATORIAL GUINEA",
        "CountryCode": "+240",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gq.svg"
    },
    {
        "CountryId": 105,
        "Country": "ERITREA",
        "CountryCode": "+291",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/er.svg"
    },
    {
        "CountryId": 108,
        "Country": "ESTONIA",
        "CountryCode": "+372",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ee.svg"
    },
    {
        "CountryId": 109,
        "Country": "ETHIOPIA",
        "CountryCode": "+251",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/et.svg"
    },
    {
        "CountryId": 110,
        "Country": "FAEROE",
        "CountryCode": "+298",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/fo.svg"
    },
    {
        "CountryId": 111,
        "Country": "FALKLAND ISLAND",
        "CountryCode": "+500",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 112,
        "Country": "FIJI",
        "CountryCode": "+679",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/fj.svg"
    },
    {
        "CountryId": 113,
        "Country": "FINLAND",
        "CountryCode": "+358",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/fi.svg"
    },
    {
        "CountryId": 117,
        "Country": "FRANCE",
        "CountryCode": "+33",
        "TIMEZONE": 16,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/fr.svg"
    },
    {
        "CountryId": 123,
        "Country": "FRENCH GUYANA",
        "CountryCode": "+594",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gf.svg"
    },
    {
        "CountryId": 124,
        "Country": "FRENCH POLYNESIA",
        "CountryCode": "+689",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/pf.svg"
    },
    {
        "CountryId": 125,
        "Country": "GABON",
        "CountryCode": "+241",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ga.svg"
    },
    {
        "CountryId": 126,
        "Country": "GAMBIA",
        "CountryCode": "+220",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gm.svg"
    },
    {
        "CountryId": 127,
        "Country": "GEORGIA",
        "CountryCode": "+995",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ge.svg"
    },
    {
        "CountryId": 132,
        "Country": "GERMANY",
        "CountryCode": "+49",
        "TIMEZONE": 23,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/de.svg"
    },
    {
        "CountryId": 137,
        "Country": "GHANA",
        "CountryCode": "+233",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gh.svg"
    },
    {
        "CountryId": 139,
        "Country": "GIBRALTER",
        "CountryCode": "+350",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gi.svg"
    },
    {
        "CountryId": 140,
        "Country": "GREECE",
        "CountryCode": "+30",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gr.svg"
    },
    {
        "CountryId": 144,
        "Country": "GREENLAND",
        "CountryCode": "+299",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gl.svg"
    },
    {
        "CountryId": 145,
        "Country": "GRENADA",
        "CountryCode": "+1473",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gd.svg"
    },
    {
        "CountryId": 146,
        "Country": "GUADELOUPE",
        "CountryCode": "+590",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gp.svg"
    },
    {
        "CountryId": 147,
        "Country": "GUAM",
        "CountryCode": "+671",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gu.svg"
    },
    {
        "CountryId": 148,
        "Country": "GUATEMALA",
        "CountryCode": "+502",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gt.svg"
    },
    {
        "CountryId": 149,
        "Country": "GUINEA BISSAU REPUBLIC",
        "CountryCode": "+245",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gw.svg"
    },
    {
        "CountryId": 150,
        "Country": "GUINEA REPUBLIC",
        "CountryCode": "+224",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/gui.svg"
    },
    {
        "CountryId": 151,
        "Country": "GUYANA REPUBLIC",
        "CountryCode": "+592",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gy.svg"
    },
    {
        "CountryId": 152,
        "Country": "HAITI REPUBLIC",
        "CountryCode": "+509",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ht.svg"
    },
    {
        "CountryId": 153,
        "Country": "HONDURAS REPUBLIC",
        "CountryCode": "+504",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/hn.svg"
    },
    {
        "CountryId": 154,
        "Country": "HONGKONG",
        "CountryCode": "+852",
        "TIMEZONE": 22,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/hk.svg"
    },
    {
        "CountryId": 155,
        "Country": "HUNGARY",
        "CountryCode": "+36",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/hu.svg"
    },
    {
        "CountryId": 161,
        "Country": "ICELAND",
        "CountryCode": "+354",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/is.svg"
    },
    {
        "CountryId": 162,
        "Country": "IMMERSAT",
        "CountryCode": "+882",
        "TIMEZONE": 6,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 392,
        "Country": "INDIA",
        "CountryCode": "+91",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/in.svg"
    },
    {
        "CountryId": 164,
        "Country": "INDONESIA",
        "CountryCode": "+62",
        "TIMEZONE": 5,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/id.svg"
    },
    {
        "CountryId": 165,
        "Country": "IRAN",
        "CountryCode": "+98",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ir.svg"
    },
    {
        "CountryId": 166,
        "Country": "IRAQ",
        "CountryCode": "+964",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/iq.svg"
    },
    {
        "CountryId": 167,
        "Country": "IRELAND",
        "CountryCode": "+353",
        "TIMEZONE": 15,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ie.svg"
    },
    {
        "CountryId": 172,
        "Country": "ISRAEL",
        "CountryCode": "+972",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/il.svg"
    },
    {
        "CountryId": 173,
        "Country": "ITALY",
        "CountryCode": "+39",
        "TIMEZONE": 23,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/it.svg"
    },
    {
        "CountryId": 177,
        "Country": "IVORY COAST",
        "CountryCode": "+225",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/ivo.svg"
    },
    {
        "CountryId": 179,
        "Country": "JAMAICA",
        "CountryCode": "+1876",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/jm.svg"
    },
    {
        "CountryId": 180,
        "Country": "JAPAN",
        "CountryCode": "+81",
        "TIMEZONE": 7,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/jp.svg"
    },
    {
        "CountryId": 181,
        "Country": "JORDAN",
        "CountryCode": "+962",
        "TIMEZONE": 24,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/jo.svg"
    },
    {
        "CountryId": 182,
        "Country": "KAZAKHSTAN",
        "CountryCode": "+77",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/kz.svg"
    },
    {
        "CountryId": 184,
        "Country": "KENYA REPUBLIC",
        "CountryCode": "+254",
        "TIMEZONE": 8,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ke.svg"
    },
    {
        "CountryId": 186,
        "Country": "KIRIBATI",
        "CountryCode": "+686",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ki.svg"
    },
    {
        "CountryId": 187,
        "Country": "KUWAIT",
        "CountryCode": "+965",
        "TIMEZONE": 9,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/kw.svg"
    },
    {
        "CountryId": 189,
        "Country": "KYRGYZSTAN ",
        "CountryCode": "+996",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/kg.svg"
    },
    {
        "CountryId": 192,
        "Country": "LAOS",
        "CountryCode": "+856",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/la.svg"
    },
    {
        "CountryId": 193,
        "Country": "LATVIA",
        "CountryCode": "+371",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/lv.svg"
    },
    {
        "CountryId": 195,
        "Country": "LEBANON",
        "CountryCode": "+961",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/lb.svg"
    },
    {
        "CountryId": 196,
        "Country": "LESOTHO",
        "CountryCode": "+266",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ls.svg"
    },
    {
        "CountryId": 198,
        "Country": "LIBERIA REPUBLIC",
        "CountryCode": "+231",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/lr.svg"
    },
    {
        "CountryId": 199,
        "Country": "LIBYA",
        "CountryCode": "+218",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ly.svg"
    },
    {
        "CountryId": 202,
        "Country": "LIECHTENSTEIN",
        "CountryCode": "+423",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/li.svg"
    },
    {
        "CountryId": 206,
        "Country": "LITHUANIA",
        "CountryCode": "+370",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/lt.svg"
    },
    {
        "CountryId": 209,
        "Country": "LUXEMBOURG",
        "CountryCode": "+352",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/lu.svg"
    },
    {
        "CountryId": 210,
        "Country": "MACAU",
        "CountryCode": "+853",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mo.svg"
    },
    {
        "CountryId": 211,
        "Country": "MACEDONIA",
        "CountryCode": "+389",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mk.svg"
    },
    {
        "CountryId": 215,
        "Country": "MADAGASCAR",
        "CountryCode": "+261",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mg.svg"
    },
    {
        "CountryId": 216,
        "Country": "MALAWI",
        "CountryCode": "+265",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mw.svg"
    },
    {
        "CountryId": 217,
        "Country": "MALAYSIA",
        "CountryCode": "+60",
        "TIMEZONE": 10,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/my.svg"
    },
    {
        "CountryId": 218,
        "Country": "MALDIVES",
        "CountryCode": "+960",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mv.svg"
    },
    {
        "CountryId": 219,
        "Country": "MALI REPUBLIC",
        "CountryCode": "+223",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ml.svg"
    },
    {
        "CountryId": 222,
        "Country": "MALTA",
        "CountryCode": "+356",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mt.svg"
    },
    {
        "CountryId": 223,
        "Country": "MARIANA ISLAND",
        "CountryCode": "+670",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/mar.svg"
    },
    {
        "CountryId": 224,
        "Country": "MARISAT",
        "CountryCode": "+873",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 225,
        "Country": "MARISAT ATLANTIC",
        "CountryCode": "+870",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 226,
        "Country": "MARISAT PACIFIC",
        "CountryCode": "+872",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 227,
        "Country": "MARSHAL ISLAND",
        "CountryCode": "+692",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mh.svg"
    },
    {
        "CountryId": 228,
        "Country": "MARTINIQUE",
        "CountryCode": "+596",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mq.svg"
    },
    {
        "CountryId": 229,
        "Country": "MAURITANIA",
        "CountryCode": "+222",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mr.svg"
    },
    {
        "CountryId": 230,
        "Country": "MAURITIUS",
        "CountryCode": "+230",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mu.svg"
    },
    {
        "CountryId": 231,
        "Country": "MEXICO",
        "CountryCode": "+52",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mx.svg"
    },
    {
        "CountryId": 232,
        "Country": "MICRONESIA (FEDERAL)",
        "CountryCode": "+691",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/mic.svg"
    },
    {
        "CountryId": 234,
        "Country": "MOLDOVA",
        "CountryCode": "+373",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/md.svg"
    },
    {
        "CountryId": 237,
        "Country": "MONACO",
        "CountryCode": "+377",
        "TIMEZONE": 23,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mc.svg"
    },
    {
        "CountryId": 238,
        "Country": "MONGOLIA",
        "CountryCode": "+976",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mn.svg"
    },
    {
        "CountryId": 239,
        "Country": "MONTSERRAT",
        "CountryCode": "+1664",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ms.svg"
    },
    {
        "CountryId": 240,
        "Country": "MOROCCO",
        "CountryCode": "+212",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ma.svg"
    },
    {
        "CountryId": 241,
        "Country": "MOZAMBIQUE",
        "CountryCode": "+258",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mz.svg"
    },
    {
        "CountryId": 243,
        "Country": "MYANMAR",
        "CountryCode": "+95",
        "TIMEZONE": 18,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/mm.svg"
    },
    {
        "CountryId": 244,
        "Country": "NAMIBIA",
        "CountryCode": "+264",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/na.svg"
    },
    {
        "CountryId": 245,
        "Country": "NAURU",
        "CountryCode": "+674",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/nr.svg"
    },
    {
        "CountryId": 246,
        "Country": "NEPAL",
        "CountryCode": "+977",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/np.svg"
    },
    {
        "CountryId": 247,
        "Country": "NETHERLANDS",
        "CountryCode": "+31",
        "TIMEZONE": 16,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/nl.svg"
    },
    {
        "CountryId": 254,
        "Country": "NEW ZEALAND",
        "CountryCode": "+64",
        "TIMEZONE": 19,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/nz.svg"
    },
    {
        "CountryId": 257,
        "Country": "NICARAGUA",
        "CountryCode": "+505",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ni.svg"
    },
    {
        "CountryId": 260,
        "Country": "NIGER REPUBLIC",
        "CountryCode": "+227",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ne.svg"
    },
    {
        "CountryId": 262,
        "Country": "NIGERIA",
        "CountryCode": "+234",
        "TIMEZONE": 11,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ng.svg"
    },
    {
        "CountryId": 263,
        "Country": "NIUE ISLAND",
        "CountryCode": "+683",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/nu.svg"
    },
    {
        "CountryId": 264,
        "Country": "NORFOLK ISLAND",
        "CountryCode": "+672",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/nf.svg"
    },
    {
        "CountryId": 265,
        "Country": "NORTH KOREA",
        "CountryCode": "+850",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/kp.svg"
    },
    {
        "CountryId": 266,
        "Country": "NORWAY",
        "CountryCode": "+47",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/no.svg"
    },
    {
        "CountryId": 271,
        "Country": "OMAN",
        "CountryCode": "+968",
        "TIMEZONE": 12,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/om.svg"
    },
    {
        "CountryId": 999,
        "Country": "Other",
        "CountryCode": "+0",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 273,
        "Country": "PAKISTAN",
        "CountryCode": "+92",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/pk.svg"
    },
    {
        "CountryId": 274,
        "Country": "PALAU",
        "CountryCode": "+680",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/pw.svg"
    },
    {
        "CountryId": 275,
        "Country": "PALESTINE",
        "CountryCode": "+970",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/pal.svg"
    },
    {
        "CountryId": 276,
        "Country": "PANAMA",
        "CountryCode": "+507",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/pa.svg"
    },
    {
        "CountryId": 277,
        "Country": "PAPUA- NEW-GUINEA",
        "CountryCode": "+675",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/pg.svg"
    },
    {
        "CountryId": 278,
        "Country": "PARAGUAY",
        "CountryCode": "+595",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/py.svg"
    },
    {
        "CountryId": 279,
        "Country": "PERU",
        "CountryCode": "+51",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/pe.svg"
    },
    {
        "CountryId": 280,
        "Country": "PHILIPPINES",
        "CountryCode": "+63",
        "TIMEZONE": 21,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ph.svg"
    },
    {
        "CountryId": 281,
        "Country": "POLAND",
        "CountryCode": "+48",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/pl.svg"
    },
    {
        "CountryId": 285,
        "Country": "PORTUGAL",
        "CountryCode": "+351",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/pt.svg"
    },
    {
        "CountryId": 286,
        "Country": "PUERTO RICO",
        "CountryCode": "+1787",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/pr.svg"
    },
    {
        "CountryId": 288,
        "Country": "QATAR",
        "CountryCode": "+974",
        "TIMEZONE": 2,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/qa.svg"
    },
    {
        "CountryId": 289,
        "Country": "ROMANIA",
        "CountryCode": "+40",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ro.svg"
    },
    {
        "CountryId": 293,
        "Country": "RUNION ISLAND",
        "CountryCode": "+262",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/run.svg"
    },
    {
        "CountryId": 294,
        "Country": "RUSSIA",
        "CountryCode": "+7",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ru.svg"
    },
    {
        "CountryId": 299,
        "Country": "RWANDA REPUBLIC",
        "CountryCode": "+250",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/rw.svg"
    },
    {
        "CountryId": 300,
        "Country": "SAIPAN",
        "CountryCode": "+1670",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 302,
        "Country": "SAMOA AMERICAN",
        "CountryCode": "+684",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/sam.svg"
    },
    {
        "CountryId": 303,
        "Country": "SAMOA WESTERN",
        "CountryCode": "+685",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ws.svg"
    },
    {
        "CountryId": 305,
        "Country": "SAN MARINO",
        "CountryCode": "+378",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sm.svg"
    },
    {
        "CountryId": 306,
        "Country": "SAOTOME PRINCIPE ISL",
        "CountryCode": "+239",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/st.svg"
    },
    {
        "CountryId": 307,
        "Country": "SATELLITE",
        "CountryCode": "+883",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 308,
        "Country": "SAUDI ARABIA",
        "CountryCode": "+966",
        "TIMEZONE": 2,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sa.svg"
    },
    {
        "CountryId": 309,
        "Country": "SENEGAL",
        "CountryCode": "+221",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sn.svg"
    },
    {
        "CountryId": 311,
        "Country": "SEYCHELLES",
        "CountryCode": "+248",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sc.svg"
    },
    {
        "CountryId": 312,
        "Country": "SIERRA LEONE",
        "CountryCode": "+232",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sl.svg"
    },
    {
        "CountryId": 313,
        "Country": "SINGAPORE",
        "CountryCode": "+65",
        "TIMEZONE": 13,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sg.svg"
    },
    {
        "CountryId": 315,
        "Country": "SLOVAKIA",
        "CountryCode": "+421",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sk.svg"
    },
    {
        "CountryId": 318,
        "Country": "SLOVENIA",
        "CountryCode": "+386",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/si.svg"
    },
    {
        "CountryId": 319,
        "Country": "SOLOMON ISLAND",
        "CountryCode": "+677",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sb.svg"
    },
    {
        "CountryId": 320,
        "Country": "SOMALIA",
        "CountryCode": "+252",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/so.svg"
    },
    {
        "CountryId": 321,
        "Country": "SOUTH AFRICA",
        "CountryCode": "+27",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/za.svg"
    },
    {
        "CountryId": 322,
        "Country": "SOUTH KOREA",
        "CountryCode": "+82",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/kr.svg"
    },
    {
        "CountryId": 323,
        "Country": "SOUTH SUDAN",
        "CountryCode": "+211",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ss.svg"
    },
    {
        "CountryId": 324,
        "Country": "SPAIN",
        "CountryCode": "+34",
        "TIMEZONE": 16,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/es.svg"
    },
    {
        "CountryId": 328,
        "Country": "SRI LANKA",
        "CountryCode": "+94",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/lk.svg"
    },
    {
        "CountryId": 329,
        "Country": "ST MAARTEN-ROC-",
        "CountryCode": "+1721",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/stp.svg"
    },
    {
        "CountryId": 330,
        "Country": "ST PIERRE & MIQUELON",
        "CountryCode": "+508",
        "TIMEZONE": 0,
        "CountryIcon": "https://pbqa.policybazaar.com/cdn/images/flag/flagna.svg"
    },
    {
        "CountryId": 331,
        "Country": "ST. DENIS",
        "CountryCode": "+282",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/std.svg"
    },
    {
        "CountryId": 332,
        "Country": "ST. HELENA",
        "CountryCode": "+290",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/sth.svg"
    },
    {
        "CountryId": 333,
        "Country": "ST. KITTS & NEVIS",
        "CountryCode": "+1869",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/stk.svg"
    },
    {
        "CountryId": 334,
        "Country": "ST. LUCIA",
        "CountryCode": "+1758",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/stl.svg"
    },
    {
        "CountryId": 335,
        "Country": "ST.VINCENT & GRENADI",
        "CountryCode": "+1784",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/stv.svg"
    },
    {
        "CountryId": 336,
        "Country": "SUDAN DEMO. REP",
        "CountryCode": "+249",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sd.svg"
    },
    {
        "CountryId": 338,
        "Country": "SURINAM REPUBLIC",
        "CountryCode": "+597",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sr.svg"
    },
    {
        "CountryId": 339,
        "Country": "SWAZILAND",
        "CountryCode": "+268",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sz.svg"
    },
    {
        "CountryId": 340,
        "Country": "SWEDEN",
        "CountryCode": "+46",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/se.svg"
    },
    {
        "CountryId": 345,
        "Country": "SWITZERLAND",
        "CountryCode": "+41",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ch.svg"
    },
    {
        "CountryId": 349,
        "Country": "SYRIA",
        "CountryCode": "+963",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/sy.svg"
    },
    {
        "CountryId": 350,
        "Country": "TAIWAN",
        "CountryCode": "+886",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/tw.svg"
    },
    {
        "CountryId": 351,
        "Country": "TAJIKISTAN",
        "CountryCode": "+992",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/tj.svg"
    },
    {
        "CountryId": 354,
        "Country": "TANZANIA",
        "CountryCode": "+255",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/tz.svg"
    },
    {
        "CountryId": 355,
        "Country": "THAILAND",
        "CountryCode": "+66",
        "TIMEZONE": 20,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/th.svg"
    },
    {
        "CountryId": 356,
        "Country": "TOGO LESE REP",
        "CountryCode": "+228",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/tog.svg"
    },
    {
        "CountryId": 358,
        "Country": "TOKELAU",
        "CountryCode": "+690",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/tk.svg"
    },
    {
        "CountryId": 359,
        "Country": "TONGA",
        "CountryCode": "+676",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/to.svg"
    },
    {
        "CountryId": 360,
        "Country": "TRINIDAD & TOBAGO",
        "CountryCode": "+1868",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/tt.svg"
    },
    {
        "CountryId": 361,
        "Country": "TUNISIA",
        "CountryCode": "+216",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/tn.svg"
    },
    {
        "CountryId": 362,
        "Country": "TURKEY",
        "CountryCode": "+90",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/tr.svg"
    },
    {
        "CountryId": 366,
        "Country": "TURKMENISTAN",
        "CountryCode": "+993",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/tm.svg"
    },
    {
        "CountryId": 367,
        "Country": "TURKS & CAUCUS",
        "CountryCode": "+1649",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/tc.svg"
    },
    {
        "CountryId": 368,
        "Country": "TUVALU",
        "CountryCode": "+688",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/tv.svg"
    },
    {
        "CountryId": 369,
        "Country": "UGANDA",
        "CountryCode": "+256",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ug.svg"
    },
    {
        "CountryId": 372,
        "Country": "UKRAINE",
        "CountryCode": "+380",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ua.svg"
    },
    {
        "CountryId": 375,
        "Country": "UNITED ARAB EMIRATES",
        "CountryCode": "+971",
        "TIMEZONE": 12,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ae.svg"
    },
    {
        "CountryId": 376,
        "Country": "UNITED KINGDOM",
        "CountryCode": "+44",
        "TIMEZONE": 14,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/gb.svg"
    },
    {
        "CountryId": 377,
        "Country": "URUGUAY",
        "CountryCode": "+598",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/uy.svg"
    },
    {
        "CountryId": 378,
        "Country": "USA/CANADA",
        "CountryCode": "+1",
        "TIMEZONE": 3,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/us.svg"
    },
    {
        "CountryId": 379,
        "Country": "UZBEKISTAN",
        "CountryCode": "+998",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/uz.svg"
    },
    {
        "CountryId": 382,
        "Country": "VANUATU NEW HEBRIDES",
        "CountryCode": "+678",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/vu.svg"
    },
    {
        "CountryId": 383,
        "Country": "VENEZUELA",
        "CountryCode": "+58",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ve.svg"
    },
    {
        "CountryId": 384,
        "Country": "VIETNAM",
        "CountryCode": "+84",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/vn.svg"
    },
    {
        "CountryId": 385,
        "Country": "WALLIS & FUTUNA",
        "CountryCode": "+681",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/wf.svg"
    },
    {
        "CountryId": 386,
        "Country": "YEMEN",
        "CountryCode": "+967",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/ye.svg"
    },
    {
        "CountryId": 387,
        "Country": "YUGOSLAVIA",
        "CountryCode": "+381",
        "TIMEZONE": 0,
        "CountryIcon": "https://static.pbcdn.in/myaccount-cdn/images/countyflags/yug.svg"
    },
    {
        "CountryId": 389,
        "Country": "ZAMBIA",
        "CountryCode": "+260",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/zm.svg"
    },
    {
        "CountryId": 390,
        "Country": "ZIMBABWE",
        "CountryCode": "+263",
        "TIMEZONE": 0,
        "CountryIcon": "https://caccount.policybazaar.com/Content/countryIcon/zw.svg"
    }
]

module.exports = { CountryJson, flag_base_path, flag_base_path_static, CDN_IMG_BASEURL }